import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { H1, Loading, IconLinkButton, DeleteButton, AccessCheck } from "@components";
import { useFetchLanguage } from "features/languages/hooks/useFetchLanguage";
import { languagesService } from "features/languages/services/languages-services";
import type { FormAction } from "features/users/types";
import { LanguageForm } from "features/languages/components/LanguageForm/LanguageForm";
import { UserRoleEnum } from "features/users/types";
import { isLanguageDeletable } from "features/languages/utils";

export const LanguagePage = ({ action = "read" }: { action?: FormAction }) => {
  const { id } = useParams();

  const [language, isFetching] = useFetchLanguage(id!, action === "create");

  if (isFetching) {
    return <Loading />;
  }

  if (!language) {
    return null;
  }

  const hasEditAccess = true;
  const isCreate = action === "create";
  const isEdit = action === "edit";
  const isRead = action === "read";
  // eslint-disable-next-line no-nested-ternary
  const h1Label = isCreate ? "Create Language" : isEdit ? "Edit Language" : "Language";
  const editLink = `/languages/${id}/edit`;
  const isDeletable = hasEditAccess && id && !isCreate && isLanguageDeletable(id);

  return (
    <AccessCheck minAccessLevel={UserRoleEnum.Admin}>
      <H1 label={h1Label}>
        <Box sx={{ display: "flex", gap: 3 }}>
          {hasEditAccess && id && isRead ? <IconLinkButton to={editLink} replace /> : null}
          {isDeletable ? (
            <DeleteButton id={id} deleteService={languagesService.deleteLanguage} label="Language" />
          ) : null}
        </Box>
      </H1>
      <LanguageForm action={action} hasEditAccess={hasEditAccess} language={language} />
    </AccessCheck>
  );
};
